import {User} from './user.class';
import {RealtimeInterface} from '../services/realtime/realtime-interface';

export class Leave implements RealtimeInterface {
    id: number;
    leave_type: string;
    comment: string;
    public_comment: string;
    user_id: number;
    users: User[] = [];

    common: boolean;
    begindate: Date;
    enddate: Date;
    begintime: string;
    endtime: string;
    interval_week: number;
    repeat_monday: boolean = false;
    repeat_tuesday: boolean = false;
    repeat_wednesday: boolean = false;
    repeat_thursday: boolean = false;
    repeat_friday: boolean = false;
    repeat_saturday: boolean = false;
    repeat_sunday: boolean = false;

    approved_at?: Date;
    approved_by?: number;

    updated_at: Date;
    deleted_at?: Date;
}

export class LeaveType {
    key: string;
    name: string;
    description?: string;
    color?: string;
    allowed_user: boolean;
    work_project_id?: number;
}
